import { IPartnerFlags } from 'clickNgo/entities/partner/models'

import { BLACKLIST_FLAG } from '../configs'

export function checkBlackListFlag(partnerFlags: IPartnerFlags) {
  const allFlags = [
    ...partnerFlags.program,
    ...partnerFlags.accreditation,
    ...partnerFlags.agreement,
  ]
  return allFlags.find(
    (flag) =>
      flag.code === BLACKLIST_FLAG && (!flag.status || !['Rejected', 'Done'].includes(flag.status))
  )
}
